import AOS from 'aos'
import React, { useEffect, useMemo } from 'react'
import { Route, Switch, useLocation } from 'react-router-dom'

import config from './config'
import routes from './routes'

import { PreCache } from './containers/PreCache'

import Media from 'react-media'

import { SIZES } from './styles/theme'

import AuditoriumContainer from './containers/AuditoriumContainer'
import PrivateRoute from './containers/PrivateRoute'
import MobileLobby from './mobileOnlyPages/MobileLobby'
import MobileNotifications from './mobileOnlyPages/MobileNotifications'
import { MobileOnDemand } from './mobileOnlyPages/MobileOnDemand'
import ActiveUserCountPage from './pages/ActiveUserCountPage'
import { AdminLiveQuestionPage } from './pages/AdminLiveQuestionPage'
import CountdownTimer from './pages/CountdownTimer'
import CountdownTimerMobile from './pages/CountdownTimerMobile'
import GamePage from './pages/game/GamePage'
import LandingPage from './pages/LandingPage'
import { LoginPage } from './pages/LoginPage'
import PhysicalProgrammePage from './pages/PhysicalProgrammePage'
import Register from './pages/register/RegisterContainer'
import SpeakerProfilePage from './pages/SpeakerProfilePage'
import TestLivePage from './pages/TestLivePage'
import BoothPage from './webOnlyPages/BoothPage'
import { DesktopOnDemand } from './webOnlyPages/DesktopOnDemand'
import { LobbyPage } from './webOnlyPages/LobbyPage'
import MobileBooth from './webOnlyPages/MobileBooth'
import NetworkingLoungePage from './webOnlyPages/NetworkingLoungePage'
import NetworkingLoungePageMobile from './webOnlyPages/NetworkingLoungePageMobile'
import Leaderboard from './pages/leaderboard/Leaderboard'
import LuckyDrawPage from './pages/lucky-draw'

declare global {
  interface Window {
    chaport: any
  }
}
// ReactGA.initialize('G-YTL11PFZRT')

function App() {
  const location = useLocation()

  useEffect(() => {
    document.title = config.eventName
    // window.chaport.q('hideLauncher')

    AOS.init({
      easing: 'ease-in-out',
      once: true,
      offset: 50,
      anchorPlacement: 'top-bottom',
    })
  }, [])

  // useEffect(() => {
  //   if (process.env.NODE_ENV === 'production') {
  //     ReactGA.send({
  //       hitType: 'pageview',
  //       page: location.pathname + location.search,
  //     })
  //   }
  // }, [location])

  return useMemo(() => {
    return (
      <div id="innerBody">
        <PreCache deviceType={'desktop'}>
          <Switch>
            <Route exact path={routes.register} component={Register} />
            <Route
              exact
              path={routes.root}
              render={() => {
                const now = new Date()
                const eventStart = new Date(
                  config.EVENT_START_TIME.year,
                  config.EVENT_START_TIME.month - 1, // Month is 0-indexed
                  config.EVENT_START_TIME.day,
                  config.EVENT_START_TIME.hour,
                  config.EVENT_START_TIME.minute
                )

                const isEventStarted = now >= eventStart

                if (isEventStarted) {
                  return <LoginPage />
                }

                return <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>{(matches) => (matches ? <CountdownTimerMobile /> : <CountdownTimer />)}</Media>
              }}
            />
            <Route exact path={routes.login} component={LoginPage} />

            <Route exact path={routes.programme} component={PhysicalProgrammePage} />
            <Route exact path={routes.speakers} component={SpeakerProfilePage} />
            <Route exact path={routes.test} component={TestLivePage} />

            {/* <Route exact path="/session-reports" component={SessionReportPage} /> */}
            <PrivateRoute blockedRoles={['participant', 'exhibitor', 'speaker']} exact path={routes.questions} component={AdminLiveQuestionPage} />
            <PrivateRoute blockedRoles={['participant', 'exhibitor', 'speaker']} exact path="/realtime" component={ActiveUserCountPage} />
            {/* <PrivateRoute blockedRoles={['participant', 'exhibitor', 'speaker']} exact path="/sessions" component={UserSessionPage} /> */}
          </Switch>
        </PreCache>

        <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
          {(matches) =>
            matches ? (
              // MOBILE ROUTES
              <PreCache deviceType={'mobile'}>
                <Switch>
                  <PrivateRoute mobileNav path={routes.lobby} component={MobileLobby} />
                  <PrivateRoute mobileNav path={routes.auditorium} component={AuditoriumContainer} />
                  <PrivateRoute mobileNav path={routes.notifications} component={MobileNotifications} />
                  <PrivateRoute mobileNav path="/booths/:boothId" component={MobileBooth} />
                  <PrivateRoute mobileNav path={routes.onDemand} component={MobileOnDemand} />
                  <PrivateRoute mobileNav path={routes.networking} component={NetworkingLoungePageMobile} />
                  <PrivateRoute path={routes.game} component={Leaderboard} />
                  <PrivateRoute path={routes.leaderboard} component={Leaderboard} />
                </Switch>
              </PreCache>
            ) : (
              // DESKTOP ROUTES
              <PreCache deviceType={'desktop'}>
                <Switch>
                  <PrivateRoute fixedNav path={routes.lobby} component={LobbyPage} />
                  <PrivateRoute fixedNav path={routes.auditorium} component={AuditoriumContainer} />
                  <PrivateRoute fixedNav path="/booths/:boothId" component={BoothPage} />
                  <PrivateRoute fixedNav path={routes.onDemand} component={DesktopOnDemand} />
                  <PrivateRoute fixedNav path={routes.networking} component={NetworkingLoungePage} />
                  <PrivateRoute fixedNav path={routes.game} component={Leaderboard} />
                  <PrivateRoute fixedNav path={routes.leaderboard} component={Leaderboard} />
                  <PrivateRoute notice={false} path={routes.luckyDraw} component={LuckyDrawPage} />
                  <PrivateRoute fixedNav path={'/admin/game'} component={GamePage} />
                </Switch>
              </PreCache>
            )
          }
        </Media>
      </div>
    )
  }, [])
}

export default App
